var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.91933V1.47133C2.81495e-05 1.3395 0.0391425 1.21064 0.112399 1.10103C0.185655 0.991422 0.289764 0.905995 0.411563 0.855549C0.533363 0.805102 0.667384 0.7919 0.796686 0.817612C0.925988 0.843324 1.04476 0.906795 1.138 1L4.86199 4.724C4.98697 4.84902 5.05718 5.01856 5.05718 5.19533C5.05718 5.37211 4.98697 5.54165 4.86199 5.66667L1.138 9.39067C1.04476 9.48387 0.925988 9.54734 0.796686 9.57306C0.667384 9.59877 0.533363 9.58557 0.411563 9.53512C0.289764 9.48467 0.185655 9.39925 0.112399 9.28964C0.0391425 9.18003 2.81495e-05 9.05117 0 8.91933Z",
    fill: "#735BF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/nextIcon.5a8e2abb315f9801c3fd3d287f6d88d7.svg";
export { ForwardRef as ReactComponent };